import Divider from "@material-ui/core/esm/Divider";
import React from 'react';
import useStyles from './DividerStyles';
export default function DividerComponent({
  hasDefaultSpacing,
  className
}) {
  const {
    divider
  } = useStyles();
  return /*#__PURE__*/React.createElement(Divider, {
    className: hasDefaultSpacing ? ` ${divider} ${className}` : `${className}`
  });
}
DividerComponent.defaultProps = {
  hasDefaultSpacing: true,
  className: ''
};